import React from 'react';
import { Skeleton, Spin, Typography } from 'antd';

const { Text } = Typography;

/**
 * First-load state shared by the Analytiikka pages, Company Identity views and
 * similar data-backed screens: the same small spinner + label + skeleton family
 * the AI report modals use, instead of a bare <Spin /> on an otherwise empty view.
 */
const ViewLoading = ({ label, rows = 6 }) => (
    <div style={{ padding: '0.5rem 0.25rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
            <Spin size="small" />
            {label && <Text type="secondary">{label}</Text>}
        </div>
        <Skeleton active title={{ width: '45%' }} paragraph={{ rows }} />
    </div>
);

export default ViewLoading;
